<template>
  <div class="o-uploader">
    <div class="m-file-uploader" v-if="files.length === 0">
      <button
        class="a-button a-button_icon-uploader"
        @click="() => doUploadFile()"
      >
        Прикрепить файлы
      </button>
      <span class="m-file-uploader__item-num">(каждый не более 1000 Mb)</span>
    </div>
    <div class="m-file-uploader" v-if="files.length > 0">
      <button
        class="a-button a-button_icon-uploader"
        @click="() => doUploadFile()"
      />
      <div class="m-file-uploader__list" ref="file_list">
        <div
          class="m-file-uploader__item"
          v-for="(file, i) in files"
          :key="'f-' + i"
          :ref="`file_item_${i}`"
        >
          <template v-if="file.error">
            <span class="m-file-uploader__item-file error">
              {{ file.error }}
            </span>
          </template>
          <template v-else>
            <span class="m-file-uploader__item-file">
              {{ file.name }}
            </span>
            <span
              class="m-file-uploader__item-num"
              v-if="file.progress !== undefined"
            >
              ({{ file.progress | percent(file.size) }}%)
            </span>
            <span
              class="m-file-uploader__item-num"
              v-if="file.progress === undefined"
            >
              ({{ file.size | humanSize }})
            </span>
            <span
              class="m-file-uploader__item-button"
              @click="doRemoveFile(file)"
            />
          </template>
        </div>
      </div>
      <button
        class="a-button a-button_icon-uploader-next"
        v-if="fileListBig && !show_end"
        @click="doMoveRight"
      />
      <button
        class="a-button a-button_icon-uploader-prev"
        v-if="fileListBig && show_end"
        @click="doMoveLeft"
      />
    </div>
    <OQModal v-if="show_error_popup" @onHide="show_error_popup = false">
      <div class="o-form__block">
        <span class="m-field m-field__label">
          {{ error_popup_message }}
        </span>
      </div>
    </OQModal>
  </div>
</template>

<script>
import FileUtils from "@/utils/fileUtils";
import OQModal from "@/components/UI/OQModal";
const BADGE_TIME = 30 * 1000;
export default {
  name: "OQSimpleFileUploader",
  components: {
    OQModal,
  },
  props: ["formats", "mimes", "value"],
  computed: {},
  filters: {
    percent: function (value, max_size) {
      if (!value && value !== 0) return "";
      return ((100.0 / +max_size) * +value).toFixed(0);
    },
    humanSize: FileUtils.human_size,
  },
  data() {
    return {
      error_file_id: 100,
      fileListBig: false,
      show_error_popup: false,
      error_popup_message: "",
      files: [],
      show_end: false,
      current_file_ref: undefined,
    };
  },
  watch: {
    files() {
      this.$emit("input", [...this.files]);
      this.$nextTick(() => {
        this.fileListBig =
          this.$refs.file_list?.clientWidth !==
          this.$refs.file_list?.scrollWidth;
      });
    },
    current_file_ref() {
      if (this.current_file_ref === this.files.length - 1) this.show_end = true;
      if (this.current_file_ref === 0) this.show_end = false;
      this.$nextTick(() => {
        const ref = this.$refs[`file_item_${this.current_file_ref}`];
        if (ref && ref[0]) {
          this.$refs.file_list.scrollTo({
            behavior: "smooth",
            left: ref[0].offsetLeft - ref[0].parentElement.offsetLeft,
          });
        }
      });
    },
  },
  beforeMount() {
    this.files = [...(this.value.files || [])];
    // this.uploading_files = [...(this.value.uploading_files || [])];
  },
  mounted() {},
  methods: {
    doRemoveFile(file) {
      let new_ref = this.files.indexOf(file) - 1;
      this.files = this.files.filter((f) => f !== file);
      if (new_ref < 0) new_ref = 0;
      if (new_ref >= this.files.length) new_ref = this.files.length - 1;

      this.current_file_ref = new_ref;
    },
    doUploadFile(files = undefined) {
      FileUtils.readNewFile(
        {
          formats: [...(this.formats || [])],
          mimes: [...(this.mimes || [])],
          files,
        },
        (options) => {
          if (options.start) {
            this.files = [
              ...this.files,
              {
                id: options.id,
                name: options.file_name,
                size: options.file_size,
                progress: options.uploaded_file_size,
              },
            ];
            this.current_file_ref = this.files.length - 1;
          } else {
            const puf = this.files.filter((uf) => uf.id === options.id)[0];
            if (puf) {
              puf.progress = options.uploaded_file_size;

              if (+puf?.progress >= +puf?.size) puf.progress = undefined;
              this.files = [...this.files];
            }
          }
        }
      )
        // eslint-disable-next-line no-unused-vars
        .then((options) => {
          // const puf = this.files.filter((uf) => uf.id === options.id)[0];
          // if (puf) puf.progress = undefined;
          this.files = [...this.files];
          this.current_file_ref = this.files.length - 1;
        })
        .catch((e) => {
          this.showErrorBadge(e);
        });
    },

    showErrorPopup(message) {
      this.error_popup_message = message;
      this.show_error_popup = true;
    },
    showErrorBadge(message) {
      this.files = [...this.files, { error: message, last_time: Date.now() }];
      this.current_file_ref = this.files.length - 1;
      this.checkErrorBadges();
    },
    checkErrorBadges() {
      if (this.files.filter((f) => f.error).length > 0) {
        setTimeout(() => {
          this.files = this.files.filter(
            (f) =>
              !f.error || (f.error && f.last_time + BADGE_TIME > Date.now())
          );
          if (this.current_file_ref >= this.files.length)
            this.current_file_ref = this.files.length - 1;
          if (this.current_file_ref < 0) this.current_file_ref = 0;

          if (this.files.length > 0) {
            this.checkErrorBadges();
          } else this.current_file_ref = undefined;
        }, BADGE_TIME);
      }
    },
    doMoveRight() {
      if (this.current_file_ref !== undefined) {
        this.current_file_ref += 1;
        if (this.current_file_ref >= this.files.length - 1) {
          this.show_end = true;
          this.current_file_ref = this.files.length - 1;
        }
      }
    },
    doMoveLeft() {
      if (this.current_file_ref !== undefined) {
        this.current_file_ref -= 1;
        if (this.current_file_ref <= 0) {
          this.show_end = false;
          this.current_file_ref = 0;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.m-file-uploader {
  display: inline-flex;
  align-items: center;
  padding: 8px 0;
  .m-file-uploader__item-num {
    padding-left: 4px;
    font-family: Font-Light, Arial, sans-serif;
    font-size: 0.875rem;
    font-weight: normal;
    line-height: 1;
    letter-spacing: normal;
    color: #909090;
    cursor: default;
  }
}

@media (max-width: 400px) {
  .m-file-uploader {
    white-space: nowrap;
    .a-button_icon-uploader {
      font-size: 0.875rem;
    }
    .m-file-uploader__item-num {
      font-family: Font-Light, Arial, sans-serif;
      font-size: 0.875rem;
      font-weight: normal;
      line-height: 1;
      letter-spacing: normal;
      color: #909090;
    }
  }
}
.m-file-uploader_end {
  display: flex;
}

.m-file-uploader_end .m-file-uploader__list {
  justify-content: flex-end;
}

.m-file-uploader__item {
  display: inline-flex;
  align-items: center;
  cursor: default;
  padding: 0px 8px;
  padding-right: 0;
  height: 24px;
  margin-left: 8px;
  white-space: nowrap;
  background-color: #f1f3f4;
  font-family: Font-Light, Arial, sans-serif;
  font-size: 0.875rem;
  font-weight: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #000;
  position: relative;
}

.m-file-uploader__item:first-child {
  margin-left: 0;
}

.m-file-uploader__list {
  display: inline-flex;
  align-items: center;
  overflow: hidden;
  flex-wrap: nowrap;
}

.m-file-uploader__item-button {
  height: 24px;
  cursor: pointer;
}

.m-file-uploader__item-button:after {
  content: "";
  width: 24px;
  height: 24px;
  display: inline-block;
  background-image: url("data:image/svg+xml,%3Csvg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 4.5L4 12.5' stroke='%236E6E6E' stroke-width='1.33333' stroke-linecap='square' stroke-linejoin='round'/%3E%3Cpath d='M4 4.5L12 12.5' stroke='%236E6E6E' stroke-width='1.33333' stroke-linecap='square' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  position: relative;
  background-position: center;
}

.m-file-uploader__item-file {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 164px;
  &.error {
    color: red;
    padding-right: 8px;
  }
}

.a-button_icon-uploader {
  width: auto;
  background: none;
  border: none;
  background-position: center;
  position: relative;
  justify-content: flex-start;
  -moz-transition: all, ease-in-out, 0.2s;
  -o-transition: all, ease-in-out, 0.2s;
  -webkit-transition: all, ease-in-out, 0.2s;
  transition: all, ease-in-out, 0.2s;
  font-family: Font-Light, Arial, sans-serif;
  font-size: 0.875rem;
  font-weight: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #000;
  padding: 0;
}

.a-button_icon-uploader:before {
  content: "";
  width: 24px;
  height: 24px;
  display: inline-block;
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20.8666 12.0421L13.2082 19.7004C12.27 20.6386 10.9976 21.1657 9.67075 21.1657C8.34393 21.1657 7.07145 20.6386 6.13325 19.7004C5.19504 18.7622 4.66797 17.4897 4.66797 16.1629C4.66797 14.8361 5.19505 13.5636 6.13325 12.6254L13.7916 4.96709C14.4171 4.34162 15.2654 3.99024 16.1499 3.99024C17.0345 3.99024 17.8828 4.34162 18.5082 4.96709C19.1337 5.59256 19.4851 6.44088 19.4851 7.32542C19.4851 8.20997 19.1337 9.05829 18.5082 9.68376L10.8416 17.3421C10.5288 17.6548 10.1047 17.8305 9.66241 17.8305C9.22014 17.8305 8.79598 17.6548 8.48325 17.3421C8.17051 17.0294 7.99482 16.6052 7.99482 16.1629C7.99482 15.7207 8.17051 15.2965 8.48325 14.9838L15.5582 7.91709' stroke='%230081BD' stroke-width='1.58333' stroke-linecap='square' stroke-linejoin='round'/%3E%3Crect x='3' y='2' width='10' height='10' rx='5' fill='white'/%3E%3Cpath d='M8 4.5V9.5' stroke='%230081BD' stroke-width='1.58333' stroke-linecap='square' stroke-linejoin='round'/%3E%3Cpath d='M5.5 7H10.5' stroke='%230081BD' stroke-width='1.58333' stroke-linecap='square' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  position: relative;
  margin-right: 8px;
  -moz-transition: all, ease-in-out, 0.2s;
  -o-transition: all, ease-in-out, 0.2s;
  -webkit-transition: all, ease-in-out, 0.2s;
  transition: all, ease-in-out, 0.2s;
}

.a-button_icon-uploader:hover {
  color: #0081bd;
}

.a-button_icon-uploader:hover:before {
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20.8666 12.044L13.2082 19.7024C12.27 20.6406 10.9976 21.1677 9.67075 21.1677C8.34393 21.1677 7.07145 20.6406 6.13325 19.7024C5.19504 18.7642 4.66797 17.4917 4.66797 16.1649C4.66797 14.8381 5.19505 13.5656 6.13325 12.6274L13.7916 4.96904C14.4171 4.34357 15.2654 3.99219 16.1499 3.99219C17.0345 3.99219 17.8828 4.34357 18.5082 4.96904C19.1337 5.59451 19.4851 6.44283 19.4851 7.32738C19.4851 8.21192 19.1337 9.06024 18.5082 9.68571L10.8416 17.344C10.5288 17.6568 10.1047 17.8325 9.66241 17.8325C9.22014 17.8325 8.79598 17.6568 8.48325 17.344C8.17051 17.0313 7.99482 16.6072 7.99482 16.1649C7.99482 15.7226 8.17051 15.2984 8.48325 14.9857L15.5582 7.91904' stroke='%23226796' stroke-width='1.58333' stroke-linecap='square' stroke-linejoin='round'/%3E%3Crect x='3' y='2' width='10' height='10' rx='5' fill='white'/%3E%3Cpath d='M8 4.5V9.5' stroke='%23226796' stroke-width='1.58333' stroke-linecap='square' stroke-linejoin='round'/%3E%3Cpath d='M5.5 7H10.5' stroke='%23226796' stroke-width='1.58333' stroke-linecap='square' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
}

.a-button_icon-remove {
  width: auto;
  background: none;
  border: none;
  background-position: center;
  position: relative;
}

.a-button_icon-remove:after {
  content: "";
  width: 24px;
  height: 24px;
  display: inline-block;
  background-image: url("data:image/svg+xml,%3Csvg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 4.5L4 12.5' stroke='%236E6E6E' stroke-width='1.33333' stroke-linecap='square' stroke-linejoin='round'/%3E%3Cpath d='M4 4.5L12 12.5' stroke='%236E6E6E' stroke-width='1.33333' stroke-linecap='square' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  position: relative;
  margin-left: 8px;
  background-position: center right;
}

.a-button_icon-uploader-next {
  width: 24px;
  height: 24px;
  background: #c4c4c4;
  border: none;
  background-position: center;
  position: relative;
  border-radius: inherit;
  -moz-transition: all, ease-in-out, 0.2s;
  -o-transition: all, ease-in-out, 0.2s;
  -webkit-transition: all, ease-in-out, 0.2s;
  transition: all, ease-in-out, 0.2s;
}

.a-button_icon-uploader-next:after {
  content: "";
  width: 16px;
  height: 16px;
  display: inline-block;
  background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 12L10 8L6 4' stroke='white' stroke-width='1.33333' stroke-linecap='square'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  position: relative;
  background-position: center;
}

.a-button_icon-uploader-next:hover {
  background: #8a8a8a;
}

.a-button_icon-uploader-prev {
  width: 24px;
  height: 24px;
  background: #c4c4c4;
  border: none;
  background-position: center;
  position: relative;
  border-radius: inherit;
  -moz-transition: all, ease-in-out, 0.2s;
  -o-transition: all, ease-in-out, 0.2s;
  -webkit-transition: all, ease-in-out, 0.2s;
  transition: all, ease-in-out, 0.2s;
}

.a-button_icon-uploader-prev:after {
  content: "";
  width: 16px;
  height: 16px;
  display: inline-block;
  transform: rotate(180deg);
  background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 12L10 8L6 4' stroke='white' stroke-width='1.33333' stroke-linecap='square'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  position: relative;
  background-position: center;
}

.a-button_icon-uploader-prev:hover {
  background: #8a8a8a;
}

.a-button_text:before {
  content: attr(data-text);
  position: relative;
}
.o-uploader {
  background-color: unset;
  & > * {
    width: 100%;
  }
  padding-bottom: 8px;
}
</style>
